export const isUserEmployee = (state) => !!state.auth.employee
